<template>
	<div class="monitor-dashboard">
		<!-- 左侧边栏 -->
		<div class="left-sidebar">
			<!-- 设备信息卡片 -->
			<div class="info-cards breath-panel">
				<div class="card">
					<div class="card-item">
						<span class="label">摄像机总数</span>
						<span class="value">{{camera_overviewData?.totalCameraCount || '0'}}路</span>
						<span class="desc">覆盖大门、办公区、泵房</span>
					</div>
					<div class="card-item">
						<span class="label">在线摄像机</span>
						<span class="value">{{camera_overviewData?.onlineCameraCount || '0'}}路</span>
						<span class="desc">在线率 100%，主备链路正常</span>
					</div>
					<div class="card-item">
						<span class="label">录像保留</span>
						<span class="value">{{camera_overviewData?.totalCameraCount || '0'}}天</span>
						<span class="desc">告警片段单独锁定归档</span>
					</div>
					<div class="card-item">
						<span class="label">今日视频告警</span>
						<span class="value">{{camera_overviewData?.todayVideoWarnCount || '0'}}起</span>
						<span class="desc">2起待复核，3起已联动</span>
					</div>
				</div>
				<!-- <div class="card full">
					<div class="card-item" style="width:100%">
						<span class="label">NVR录像容量</span>
						<div class="flex-between">
							<span class="value">8TB/已用5.4TB</span>
							<span class="desc">剩余2.6TB，预计可继续保留12天</span>
						</div>
						<div class="progress-bar">
							<div class="progress" :style="{ width: `${(5.4 / 8) * 100}%` }"></div>
						</div>
					</div>
				</div> -->
			</div>
			<!-- 视频告警 -->
			<div class="video-alarm breath-panel">
				<div class="flex-between">
					<div class="title">视频告警</div>
					<div class="desc">
						触发时间/联动动作/处置状态
					</div>
				</div>
				<div class="alarm-list">
					<div class="alarm-item" v-for="(alarm, index) in alarmList" :key="alarm.id || index" :class="{
							'urgent': alarm.warnLevel == 0,
							'warning': alarm.warnLevel == 1,
							'normal': alarm.warnLevel == 2
						}">
						<div class="alarm-content">
							<div class="alarm-title">{{ alarm.warnName }}</div>
							<div class="alarm-time">{{ alarm.warnTime }} 触发，已自动切主画面并推送值班员复核。</div>
						</div>
						<div class="alarm-action flex-start fnw">
							<span class="floor">{{ alarm.areaName }}</span>
							<span class="floor">{{ alarm.warnDealActionName || '待处理' }}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 云台与镜头控制 -->
			<div class="ptz-control breath-panel">
				<div class="flex-between aic">
					<div class="title">云台与镜头控制</div>
					<div class="desc">PTZ/预置位/镜头</div>
				</div>
				<div class="flex-center">
					<div class="ptz-buttons">
						<button class="ptz-btn" @click="control('zoomin')">放大</button>
						<!-- <button class="ptz-btn" @click="control('zoomout')">缩小</button> -->
						<!-- <button class="ptz-btn" @click="control('')">补光</button> -->
					</div>
					<div class="direction-control">
						<div class="dir-btn up" @click="control('up')">上</div>
						<div class="dir-btn left" @click="control('left')">左</div>
						<div class="dir-btn center">
							<span @click="control('stop')">停止</span>
							<!-- <span @click="control('')">预置位</span> -->
						</div>
						<div class="dir-btn right" @click="control('right')">右</div>
						<div class="dir-btn down" @click="control('down')">下</div>
					</div>
					<div class="ptz-buttons">
						<button class="ptz-btn" @click="control('zoomout')">缩小</button>
						<!-- <button class="ptz-btn" @click="control('')">雨刷</button> -->
						<!-- <button class="ptz-btn right" @click="control('')">巡航</button> -->
						<!-- <button class="ptz-btn" @click="control('')">自动对焦</button> -->
					</div>
				</div>
				<!-- 				<div class="zoom-control">
					<span class="label">镜头变焦</span>
					<div class="zoom-slider">
						<div class="slider-track">
							<div class="slider-fill" :style="{ width: '68%' }"></div>
						</div>
						<span class="value">68%</span>
					</div>
				</div> -->
			</div>
		</div>
		<!-- 中间视频监控中心 -->
		<div class="main-content breath-panel">
			<div class="header">
				<div class="title">
					<span class="dot"></span>
					<span class="text">视频监控中心</span>
				</div>
				<div class="desc">实况预览/H.265/ONVIF/主码流 25fps</div>
			</div>
			<div class="tab-buttons">
				<button class="tab-btn" :class="{ active: currentTab === 'single' }"
					@click="currentTab = 'single'">单画面</button>
				<button class="tab-btn" :class="{ active: currentTab === 'four' }"
					@click="currentTab = 'four'">四画面</button>
				<button class="tab-btn" :class="{ active: currentTab === 'nine' }"
					@click="currentTab = 'nine'">九画面</button>
			</div>
			<div class="video-container" :class="currentTab">
				<!-- 单画面 -->
				<template v-if="currentTab === 'single'">
					<div class="video-item single">
						<div class="video-header">
							<div class="camera-select" @click="toggleSelector(0)">
								<div class="">
									<div class="title">{{getCamera(0).deviceName || '请选择摄像头'}}</div>
									<div class="desc">{{getCamera(0).areaName || '--'}} / 1080P</div>
								</div>
								<img class="fh"
									:src="selectorOpen[0] ? require('@/assets/up.png') : require('@/assets/down.png')"
									alt="" />
								<div class="camera-dropdown" v-if="selectorOpen[0]" @click.stop>
									<div class="dropdown-item" v-for="(cam,ci) in camera_listData"
										:key="cam.deviceCode || ci"
										:class="{active: cam.deviceCode === gridSelections[0]}"
										@click.stop="selectCamera(0, cam)">
										<span class="name">{{cam.deviceName}}</span>
										<span class="area">{{cam.areaName}}</span>
									</div>
									<div class="dropdown-empty" v-if="!camera_listData.length">暂无摄像头</div>
								</div>
							</div>
							<span class="main-tag">主界面</span>
						</div>
						<div class="video-content">
							<div class="video-img" :ref="'jessibucaContainer_0'"></div>
							<div class="no-signal" v-if="!getCamera(0).flvStreamUrl">暂无视频信号</div>
						</div>
						<div class="video-footer">
							<div class="stat-item">
								<span class="label">门禁闸机</span>
								<span class="value">在线</span>
							</div>
							<div class="stat-item">
								<span class="label">通行</span>
								<span class="value">128次</span>
							</div>
							<div class="stat-item">
								<span class="label">人脸核验</span>
								<span class="value">98.9%</span>
							</div>
							<div class="stat-item">
								<span class="label">陌生人</span>
								<span class="value">0起</span>
							</div>
						</div>
					</div>
				</template>
				<!-- 四画面 -->
				<template v-if="currentTab === 'four'">
					<div class="video-item four" v-for="i in 4" :key="'four-'+i">
						<div class="video-header">
							<div class="camera-select" @click="toggleSelector(i-1)">
								<div class="">
									<div class="title">{{getCamera(i-1).deviceName || '请选择摄像头'}}</div>
									<div class="desc">{{getCamera(i-1).areaName || '--'}} / 1080P</div>
								</div>
								<img class="fh"
									:src="selectorOpen[i-1] ? require('@/assets/up.png') : require('@/assets/down.png')"
									alt="" />
								<div class="camera-dropdown" v-if="selectorOpen[i-1]" @click.stop>
									<div class="dropdown-item" v-for="(cam,ci) in camera_listData"
										:key="cam.deviceCode || ci"
										:class="{active: cam.deviceCode === gridSelections[i-1]}"
										@click.stop="selectCamera(i-1, cam)">
										<span class="name">{{cam.deviceName}}</span>
										<span class="area">{{cam.areaName}}</span>
									</div>
									<div class="dropdown-empty" v-if="!camera_listData.length">暂无摄像头</div>
								</div>
							</div>
							<span class="status-tag">正常</span>
						</div>
						<div class="video-content">
							<div class="video-img" :ref="'jessibucaContainer_'+(i-1)"></div>
							<div class="no-signal" v-if="!getCamera(i-1).flvStreamUrl">暂无视频信号</div>
						</div>
						<div class="video-footer">
							<div class="stat-item">
								<span class="label">在线</span>
								<span class="value">128次</span>
							</div>
							<div class="stat-item">
								<span class="label">通行</span>
								<span class="value">128次</span>
							</div>
							<div class="stat-item">
								<span class="label">人脸核验</span>
								<span class="value">98.9%</span>
							</div>
							<div class="stat-item">
								<span class="label">陌生人</span>
								<span class="value">0起</span>
							</div>
						</div>
					</div>
				</template>
				<!-- 九画面 -->
				<template v-if="currentTab === 'nine'">
					<div class="video-item nine" v-for="i in 9" :key="'nine-'+i">
						<div class="video-header">
							<div class="camera-select" @click="toggleSelector(i-1)">
								<div class="">
									<div class="title">{{getCamera(i-1).deviceName || '请选择摄像头'}}</div>
									<div class="desc">{{getCamera(i-1).areaName || '--'}} / 1080P</div>
								</div>
								<img class="fh"
									:src="selectorOpen[i-1] ? require('@/assets/up.png') : require('@/assets/down.png')"
									alt="" />
								<div class="camera-dropdown" v-if="selectorOpen[i-1]" @click.stop>
									<div class="dropdown-item" v-for="(cam,ci) in camera_listData"
										:key="cam.deviceCode || ci"
										:class="{active: cam.deviceCode === gridSelections[i-1]}"
										@click.stop="selectCamera(i-1, cam)">
										<span class="name">{{cam.deviceName}}</span>
										<span class="area">{{cam.areaName}}</span>
									</div>
									<div class="dropdown-empty" v-if="!camera_listData.length">暂无摄像头</div>
								</div>
							</div>
							<span class="status-tag">正常</span>
						</div>
						<div class="video-content">
							<div class="video-img" :ref="'jessibucaContainer_'+(i-1)"></div>
							<div class="no-signal" v-if="!getCamera(i-1).flvStreamUrl">暂无视频信号</div>
						</div>
						<div class="video-footer">
							<div class="stat-item">
								<span class="label">在线</span>
								<span class="value">128次</span>
							</div>
							<div class="stat-item">
								<span class="label">通行</span>
								<span class="value">128次</span>
							</div>
							<div class="stat-item">
								<span class="label">人脸核验</span>
								<span class="value">98.9%</span>
							</div>
							<div class="stat-item">
								<span class="label">陌生人</span>
								<span class="value">0起</span>
							</div>
						</div>

					</div>
				</template>
			</div>
		</div>
		<!-- 右侧边栏 -->
		<div class="right-sidebar ">
			<!-- 监控设置 -->
			<div class="monitor-settings breath-panel">
				<div class="title">
					<span>监控设置</span>
					<span class="subtitle">摄像机/算法/多条件阈值</span>
				</div>
				<div class="camera-selector">
					<div class="title">选择摄像头</div>
					<div class="flex-between">
						<div class="input-box" @click="settingSelectorOpen = !settingSelectorOpen">
							<span>{{ selectedSettingCamera ? selectedSettingCamera.deviceName : '请选择摄像头' }}</span>
							<img class="arrow-icon"
								:src="settingSelectorOpen ? require('@/assets/up.png') : require('@/assets/down.png')"
								alt="" />
							<!-- 下拉列表 -->
							<div class="camera-dropdown" v-if="settingSelectorOpen" @click.stop>
								<div class="dropdown-item" v-for="(cam, ci) in camera_listData"
									:key="cam.deviceCode || ci"
									:class="{ active: selectedSettingCameraCode === cam.deviceCode }"
									@click.stop="selectSettingCamera(cam)">
									<span class="name">{{ cam.deviceName }}</span>
									<span class="area">{{ cam.areaName }}</span>
								</div>
								<div class="dropdown-empty" v-if="!camera_listData.length">暂无摄像头</div>
							</div>



						</div>
						<!-- <label class="checkbox-label">
							<input type="checkbox" v-model="applyAllCameras" /> 全部摄像机
						</label> -->
					</div>
				</div>
				<div class="algo-settings">
					<div class="section-title">事件标记</div>
					<div class="algo-list" v-if="algoList.length">
						<label class="algo-item" v-for="algo in algoList" :key="algo.code">
							<input type="checkbox" :checked="algo.enabled" :disabled="algoToggling[algo.code]"
								@change="toggleAlgorithm(algo, $event.target.checked)" />
							{{ algo.name }}
						</label>
					</div>
					<div class="algo-empty" v-else>{{ algoLoading ? '加载中...' : '暂无算法配置' }}</div>
					<span class="count" v-if="algoList.length">{{ algoList.length }}类AI识别</span>
				</div>
			</div>
			<!-- 智能分析 -->
			<section class="panel-section ai-section breath-panel">
				<div class="section-header">
					<h2 class="section-title">智能分析</h2>
					<span class="subtitle">实时画面 AI 检测（仅单画面）</span>
				</div>

				<div class="ai-content">
					<div v-if="currentTab !== 'single'" class="single-only-tip">
						智能分析仅支持单画面模式，请切换到单画面
					</div>

					<template v-else>
						<div class="preset-questions">
							<div class="preset-title">快捷提问</div>
							<div class="preset-list">
								<div v-for="(q, i) in presetQuestions" :key="i" class="preset-item"
									:class="{ disabled: analyzing }" @click="askPresetQuestion(q)">
									{{ q }}
								</div>
							</div>
						</div>

						<div class="analyze-input-wrap">
							<input class="input-box" v-model="analyzeQuestion" type="text" placeholder="输入自定义问题（可选）"
								:disabled="analyzing" @keyup.enter="analyzeCurrentImage" />
							<button class="analyze-btn" :disabled="analyzing" @click="analyzeCurrentImage">
								{{ analyzing ? '分析中…' : '开始分析' }}
							</button>
						</div>

						<div v-if="analyzing" class="current-asking">
							正在分析：{{ currentAskedQuestion }}
						</div>

						<div v-if="analyzeResult" class="analyze-result">
							<div class="result-header">
								<span>✓ 分析完成</span>
								<span>{{ analyzeResult.model }} · {{ analyzeResult.costSeconds }}s</span>
							</div>
							<!-- <div class="result-block">
								<div class="label">总结</div>
								<div class="text">{{ analyzeResult.summary }}</div>
							</div> -->
							<div v-if="analyzeResult.answer" class="result-block">
								<div class="label">回答</div>
								<div class="text">{{ analyzeResult.answer }}:{{ analyzeResult.summary }}</div>
							</div>

							<div class="result-details">
								<div class="label">检测详情</div>
								<div class="detail-grid">
									<div v-for="(val, key) in analyzeResultDetails" :key="key" class="detail-item">
										<span class="k">{{ getDetailLabel(key) }}</span>
										<span class="v"
											:class="{danger: val === '是',warning: val === '不确定',normal: val === '否'}">
											{{ val }}
										</span>
									</div>
								</div>
							</div>
						</div>

						<div v-if="analyzeError" class="analyze-error">
							{{ analyzeError }}
						</div>
					</template>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
	import wsService from '@/utils/websocketService'
	export default {
		name: 'MonitorDashboard',
		data() {
			return {
				currentTab: 'single',
				camera_overviewData: {},
				camera_listData: [],
				gridSelections: [], // 每个宫格选择的摄像头deviceCode
				selectorOpen: [], // 每个宫格下拉选择器打开状态
				jessibucaPlayers: [],
				jessibucaLoaded: false,
				// 画面轮播
				carouselTimer: null, // 轮播定时器
				carouselCursor: 0, // 轮播游标（指向 validList 的起始位置）
				// 视频告警列表
				alarmList: [],
				pageNumber: 1,
				pageSize: 10,
				operation: {
					deviceCode: '',
					command: '',
				},
				analyzing: false,
				analyzeQuestion: '',
				analyzeResult: null,
				analyzeError: '',
				analyzeTimeout: 65000,
				currentAskedQuestion: '',
				lastAskedQuestion: '',
				presetQuestions: [
					'当前画面是否有异常？',
					'画面是否有遮挡？',
					'是否存在花屏或色彩异常？',
					'画面中是否有人员？',
					'摄像头视野是否被树叶或树枝遮挡？',
					'画面整体清晰度如何？',
					'是否存在局部模糊？',
					'是否存在非植物类异物遮挡？'
				],
				// 监控设置下拉选择
				settingSelectorOpen: false,
				selectedSettingCamera: null,
				selectedSettingCameraCode: '',
				applyAllCameras: false,
				// 算法设置
				algoList: [], // [{ code, name, enabled }]
				algoCommand: 'camera_algorithm_control', // 算法控制命令字
				algoOnValue: 1, // 开启值（从接口解析）
				algoOffValue: 0, // 关闭值
				algoToggling: {}, // { [code]: true } 正在切换中的算法
				algoLoading: false, // 算法配置加载中
				algoNameMap: { // 算法编码 → 中文名（接口只返回编码，名称前端映射）
					face: '人脸识别',
					vehicle: '车辆识别',
					intrusion: '越界检测',
					verify: '验放识别',
					gather: '人员聚集',
					stranger: '陌生人逗留',
					helmet: '安全帽识别',
					leave: '离岗检测',
					person: '人员识别',
					fire: '火焰识别',
					smoke: '烟雾识别',
				},
			}
		},
		computed: {
			maxGrids() {
				return this.currentTab === 'single' ? 1 : this.currentTab === 'four' ? 4 : 9
			},

			analyzeResultDetails() {
				if (!this.analyzeResult) return {}
				const keys = [
					'treeLeafBlock',
					'treeBranchBlock',
					'aerialRootBlock',
					'partialBlur',
					'lensSideLeafBlock',
					'lensSideBranchBlock',
					'colorAbnormal',
					'screenGlitch',
					'foreignBodyBlock'
				]
				return Object.fromEntries(
					keys.filter(k => this.analyzeResult[k] !== undefined)
					.map(k => [k, this.analyzeResult[k]])
				)
			}
		},
		watch: {
			currentTab() {
				// 切换 tab 时关闭所有下拉菜单
				this.selectorOpen = Array(9).fill(false)
				this.$nextTick(() => {
					this.initVideoPlayers()
				})
				// 切换 tab 后按新的宫格数重新开始轮播
				this.startCarousel()
			}
		},
		created() {
			this.camera_overview()
			this.page_warn_list()
		},
		mounted() {
			this.loadJessibuca().then(() => {
				this.camera_list()
			}).catch(err => {
				console.error('[jessibuca] 加载失败:', err)
				this.camera_list()
			})
			// 初始化告警 WebSocket
			wsService.initWarnWs(this.handleWarnMessage)
		},
		beforeDestroy() {
			this.stopCarousel()
			this.destroyAllPlayers()
			wsService.unsubscribeWarn(this.handleWarnMessage)
		},
		methods: {
			// 获取视频告警列表
			pageSetings(deviceCode = '') {
				this.algoLoading = true
				this.$http.get(this.$api.BASE_URL_Category.devSetings, {
					deviceCode: deviceCode,
				}).then(res => {
					console.log('[pageSetings] deviceCode:', deviceCode, '返回:', res)
					this.parseAlgoConfig(res.data || [])
				}).catch(err => {
					console.error('[pageSetings] 请求失败:', err)
					this.algoList = []
				}).finally(() => {
					this.algoLoading = false
				})
			},
			// 解析算法配置：筛选 command=camera_algorithm_control，解析 variable.value 取算法列表 + 启停值
			parseAlgoConfig(dataList) {
				console.log('[parseAlgoConfig] 原始数据:', dataList)
				if (!Array.isArray(dataList) || !dataList.length) {
					this.algoList = []
					return
				}

				// 1. 筛选算法控制项
				const algoItem = dataList.find(
					item => item.command === this.algoCommand
				)
				if (!algoItem) {
					console.log('[parseAlgoConfig] 该摄像头未配置算法控制能力')
					this.algoList = []
					return
				}

				let rawAlgos = []
				let onValue = 1
				let offValue = 0

				try {
					let varStr = algoItem.variable?.value
					if (!varStr) { this.algoList = []; return }
					// variable.value 可能被 $ 包裹
					if (typeof varStr === 'string' && varStr.startsWith('$') && varStr.endsWith('$')) {
						varStr = varStr.slice(1, -1)
					}
					const parsed = typeof varStr === 'string' ? JSON.parse(varStr) : varStr

					// 2. 算法列表：取 taskId.value
					const taskSource = parsed.taskId || parsed.taskSession
					if (taskSource) {
						let val = taskSource.value
						if (typeof val === 'string') {
							if (val.startsWith('$') && val.endsWith('$')) val = val.slice(1, -1)
							rawAlgos = JSON.parse(val)
						} else if (Array.isArray(val)) {
							rawAlgos = val
						}
					}

					// 3. 启停值：取 value.value → [{开启:1},{关闭:0}]
					const valSource = parsed.value || parsed.enabled
					if (valSource && Array.isArray(valSource.value)) {
						for (const item of valSource.value) {
							if (item['开启'] !== undefined) onValue = item['开启']
							if (item['关闭'] !== undefined) offValue = item['关闭']
						}
					}
				} catch (e) {
					console.error('[parseAlgoConfig] 解析失败:', e)
					this.algoList = []
					return
				}

				this.algoOnValue = onValue
				this.algoOffValue = offValue

				// 4. 映射为 { code, name, enabled }
				// rawAlgos 元素可能是：
				//   字符串 "face" → code=face, name=algoNameMap 兜底
				//   对象 {"区域入侵":"13"} → name=区域入侵, code=13
				this.algoList = rawAlgos.map(item => {
					if (typeof item === 'string') {
						return { code: item, name: this.algoNameMap[item] || item, enabled: false }
					}
					if (item && typeof item === 'object') {
						const key = Object.keys(item)[0]
						const val = item[key]
						return { code: val, name: key, enabled: false }
					}
					return null
				}).filter(Boolean)

				console.log('[parseAlgoConfig] 算法列表:', this.algoList, 'on:', onValue, 'off:', offValue)
			},
			// 切换算法启停
			async toggleAlgorithm(algo, checked) {
				const deviceCode = this.selectedSettingCameraCode || this.operation.deviceCode
				if (!deviceCode) {
					(this.$message?.warning || alert)('请先选择摄像头')
					algo.enabled = !checked
					return
				}

				this.$set(this.algoToggling, algo.code, true)
				const targetValue = checked ? this.algoOnValue : this.algoOffValue

				try {
					const res = await this.$http.post(this.$api.BASE_URL_Category.commands, {
						commands: [{
							deviceCode: deviceCode,
							command: this.algoCommand,
							variable: JSON.stringify({ taskId: algo.code, value: targetValue })
						}]
					})

					console.log('[toggleAlgorithm] 返回:', res)
					const code = res.code ?? res.data?.code
					const data = res.data ?? res

					if (code === 200 && data?.confirmed === true) {
						// 控制成功
						algo.enabled = checked
						this.$message?.success?.(`${algo.name}已${checked ? '开启' : '关闭'}`)
					} else if (data?.result === 'unconfirmed') {
						// 指令已发送但未确认 → 不改变开关状态
						algo.enabled = !checked
						this.$message?.warning?.(`${algo.name}指令已发送，未确认设备执行结果`)
					} else {
						// 控制失败 → 还原
						algo.enabled = !checked
						const msg = data?.items?.[0]?.message || res.msg || '控制失败'
						this.$message?.error?.(msg)
					}
				} catch (err) {
					console.error('[toggleAlgorithm] 请求异常:', err)
					algo.enabled = !checked
					this.$message?.error?.('控制请求失败：' + (err.message || '网络错误'))
				} finally {
					this.$set(this.algoToggling, algo.code, false)
				}
			},
			// 镜头控制
			control(command) {
				this.operation.command = command;
				this.$http.post(this.$api.BASE_URL_Category.control, this.operation).then(res => {
					console.log(res)
				})
			},
			// 获取视频告警列表
			page_warn_list() {
				this.$http.get(this.$api.BASE_URL_Category.page_warn_list, {
					pageNumber: this.pageNumber,
					pageSize: this.pageSize,
					categoryCode: 'VIDEO_ALGORITHM' // 视频算法告警
				}).then(res => {
					this.alarmList = res.data.data || []
				}).catch(err => {
					console.error('[page_warn_list] 获取视频告警列表失败：', err)
				})
			},
			// WebSocket 告警推送回调
			handleWarnMessage(message) {
				console.log('[videoManagement] 收到告警推送:', message)
				// 刷新告警列表
				this.page_warn_list()
			},
			// 监控设置 - 选择摄像头
			selectSettingCamera(cam) {
				this.selectedSettingCamera = cam
				this.selectedSettingCameraCode = cam.deviceCode
				this.settingSelectorOpen = false
				// 更新云台控制的设备代码
				this.operation.deviceCode = cam.deviceCode
				// 同步拉取该摄像头的设置
				this.pageSetings(cam.deviceCode)
				console.log('[监控设置] 选中摄像头:', cam.deviceName, cam.deviceCode)
			},
			/* ================= 智能分析 ================= */

			/** 预设问题点击 */
			askPresetQuestion(question) {
				if (this.analyzing || this.currentTab !== 'single') return
				this.analyzeQuestion = question
				this.analyzeCurrentImage()
			},
			// 通用的截图方法 - 兼容 canvas(WCS/软解) / video(MSE) / jessibuca API 三种渲染模式
			async captureCurrentFrame(index = 0) {
				const containerRef = this.$refs[`jessibucaContainer_${index}`];
				const container = Array.isArray(containerRef) ? containerRef[0] : containerRef;

				if (!container) {
					console.log('[截图] 容器不存在');
					return null;
				}

				// 抽出统一的 video 截图逻辑（MSE 模式下用 drawImage 把当前帧画到临时 canvas）
				const captureFromVideo = (video) => {
					if (!video || video.readyState < 2 || video.videoWidth <= 0) return null;
					try {
						const tmp = document.createElement('canvas');
						tmp.width = video.videoWidth;
						tmp.height = video.videoHeight;
						const ctx = tmp.getContext('2d');
						ctx.drawImage(video, 0, 0, tmp.width, tmp.height);
						const b64 = tmp.toDataURL('image/jpeg', 0.85);
						console.log('[截图] video 成功，尺寸:', tmp.width, 'x', tmp.height);
						return b64;
					} catch (e) {
						console.log('[截图] video drawImage 失败:', e?.message || e);
						return null;
					}
				};

				// 抽出统一的 canvas 截图逻辑（WCS/软解模式直接 toDataURL）
				const captureFromCanvas = (canvas) => {
					if (!canvas || canvas.width <= 0 || canvas.height <= 0) return null;
					try {
						const b64 = canvas.toDataURL('image/jpeg', 0.85);
						console.log('[截图] canvas 成功，尺寸:', canvas.width, 'x', canvas.height);
						return b64;
					} catch (e) {
						console.log('[截图] canvas toDataURL 失败:', e?.message || e);
						return null;
					}
				};

				// 1. 优先尝试 canvas（WCS / 软解模式）
				let result = captureFromCanvas(container.querySelector('canvas'));
				if (result) return result;

				// 2. 其次尝试 video（MSE 模式，当前项目配置 useMSE:true 走的就是这个）
				result = captureFromVideo(container.querySelector('video'));
				if (result) return result;

				// 3. 兜底：调用 jessibuca 内置 screenshot API，监听 'screenshot' 事件拿 base64
				const player = this.jessibucaPlayers && this.jessibucaPlayers[index];
				if (player && typeof player.screenshot === 'function') {
					try {
						const apiResult = await new Promise((resolve) => {
							let done = false;
							const finish = (data) => {
								if (done) return;
								done = true;
								try {
									player.off('screenshot', handler);
								} catch (e) {}
								resolve(data);
							};
							const handler = (data) => {
								if (typeof data === 'string' && data.length > 100) finish(data);
							};
							try {
								player.on('screenshot', handler);
							} catch (e) {}
							// 触发截图；部分版本直接返回 base64
							let ret;
							try {
								ret = player.screenshot('frame', 'base64', 0.85);
							} catch (e) {}
							if (typeof ret === 'string' && ret.startsWith('data:image')) finish(ret);
							// 超时兜底
							setTimeout(() => finish(null), 2000);
						});
						if (apiResult) {
							console.log('[截图] jessibuca API 成功');
							return apiResult;
						}
					} catch (e) {
						console.log('[截图] jessibuca API 失败:', e?.message || e);
					}
				}

				// 4. 仍无可用元素 —— 监听 DOM 变化等待 video/canvas 加载完成
				console.log('[截图] 当前无可用元素，开始监听 DOM 变化');
				return new Promise((resolve) => {
					let settled = false;
					const finish = (data) => {
						if (settled) return;
						settled = true;
						clearTimeout(timer);
						observer.disconnect();
						resolve(data);
					};

					const tryCapture = () => {
						const c = captureFromCanvas(container.querySelector('canvas'));
						if (c) {
							finish(c);
							return;
						}
						const v = captureFromVideo(container.querySelector('video'));
						if (v) {
							finish(v);
							return;
						}
					};

					const timer = setTimeout(() => {
						console.log('[截图] 等待超时');
						finish(null);
					}, 3000);

					const observer = new MutationObserver(() => {
						tryCapture();
					});
					observer.observe(container, {
						childList: true,
						subtree: true,
						attributes: true,
						attributeFilter: ['style', 'class', 'src']
					});
					// 立即再试一次，避免监听前正好就绪
					tryCapture();
				});
			},

			// 修改 analyzeCurrentImage 方法
			async analyzeCurrentImage() {
				console.log('[智能分析] 开始执行，当前模式:', this.currentTab);

				if (this.currentTab !== 'single') {
					this.$message?.warning?.('智能分析仅支持单画面模式') || alert('智能分析仅支持单画面模式');
					return;
				}

				this.analyzing = true;
				this.analyzeResult = null;
				this.analyzeError = '';
				this.currentAskedQuestion = this.analyzeQuestion || '默认画面检测';

				// 使用新的截图方法
				const base64 = await this.captureCurrentFrame(0);

				if (!base64) {
					console.log('[智能分析] 截图失败');
					this.analyzeError = '无法获取当前画面，请确认视频已加载';
					this.analyzing = false;
					this.currentAskedQuestion = '';
					return;
				}

				console.log('[智能分析] 截图成功，base64长度:', base64.length);

				// 确保 base64 格式正确
				const finalBase64 = base64.startsWith('data:image/') ? base64 : 'data:image/jpeg;base64,' + base64;
				console.log('[智能分析] 最终 base64 长度:', finalBase64.length);

				try {
					const res = await this.$http.post(
						this.$api.BASE_URL_Category.analyze_image, {
							comProjectId: '604469234560770048',
							imageBase64: finalBase64,
							imageUrl: '',
							question: this.analyzeQuestion || '',
							timeoutSeconds: 60
						}, {
							timeout: this.analyzeTimeout
						}
					);
					console.log('[智能分析] 接口返回:', res);

					if (res.data?.code === 200) {
						this.analyzeResult = res.data;
						this.lastAskedQuestion = this.currentAskedQuestion;
						this.analyzeQuestion = '';
						// this.$message.success(res.data.answer +':'+ res.data.summary)
					} else {
						this.analyzeError = res.msg || '分析失败';
					}
				} catch (err) {
					console.error('[智能分析] 请求异常:', err);
					this.analyzeError = err.message?.includes('timeout') ?
						'分析超时，请稍后重试' :
						'分析请求失败：' + (err.message || '网络错误');
				}

				this.analyzing = false;
				this.currentAskedQuestion = '';
			},

			getDetailLabel(key) {
				const map = {
					treeLeafBlock: '树叶遮挡主干道',
					treeBranchBlock: '树枝遮挡主干道',
					aerialRootBlock: '树须遮挡主干道',
					partialBlur: '局部模糊',
					lensSideLeafBlock: '镜头两侧树叶遮挡',
					lensSideBranchBlock: '镜头两侧树枝遮挡',
					colorAbnormal: '色彩异常',
					screenGlitch: '花屏异常',
					foreignBodyBlock: '非植物异物遮挡'
				}
				return map[key] || key
			},
			// 获取结果值样式
			getValueClass(value) {
				if (value === '是') return 'danger'
				if (value === '不确定') return 'warning'
				return 'normal'
			},
			// 加载 jessibuca 播放器脚本
			loadJessibuca() {
				return new Promise((resolve, reject) => {
					if (window.Jessibuca) {
						this.jessibucaLoaded = true
						resolve()
						return
					}
					const script = document.createElement('script')
					script.src = '/static/jessibuca/jessibuca.js'
					script.onload = () => {
						this.jessibucaLoaded = true
						resolve()
					}
					script.onerror = (err) => {
						reject(err)
					}
					document.head.appendChild(script)
				})
			},
			// 获取摄像头列表
			camera_list() {
				console.log('[camera_list] 开始请求')
				this.$http.get(this.$api.BASE_URL_Category.camera_list, {
					pageNumber: 1,
					pageSize: 1000
				}).then(res => {
					console.log('[camera_list] 返回:', res)
					const allList = res.data.data || []
					// 有效流排前面
					const validList = allList.filter(item => item.flvStreamUrl)
					const invalidList = allList.filter(item => !item.flvStreamUrl)
					this.camera_listData = [...validList, ...invalidList]
					// 无有效流时直接结束，避免 validList[0] 取空报错
					if (!validList.length) {
						console.warn('[camera_list] 无有效流摄像头')
						this.gridSelections = Array(9).fill('')
						this.selectorOpen = Array(9).fill(false)
						return
					}
					this.operation.deviceCode = validList[0].deviceCode
					// 默认展示第一个摄像头 → 同步监控设置下拉选中 + 拉取该摄像头的设置
					this.selectedSettingCamera = validList[0]
					this.selectedSettingCameraCode = validList[0].deviceCode
					this.pageSetings(validList[0].deviceCode)
					// 初始化宫格选择：默认选前几个有流的，不足的用空字符串占位
					const initialSelections = []
					for (let i = 0; i < 9; i++) {
						if (validList[i]) {
							initialSelections.push(validList[i].deviceCode)
						} else {
							initialSelections.push('') // 空位
						}
					}
					this.gridSelections = initialSelections
					this.selectorOpen = Array(9).fill(false)

					// console.log('[camera_list] 处理后列表长度:', this.camera_listData.length, '有效流:', validList
					// .length)
					// console.log('[camera_list] gridSelections:', this.gridSelections)
					// console.log('[camera_list] 有效流列表:', validList.map(v =>
					// 	`${v.deviceName}(${v.deviceCode})`))
					this.initVideoPlayers()
					// 摄像头列表就绪后启动 20 秒轮播
					this.startCarousel()
				}).catch(err => {
					console.error('[camera_list] 请求失败:', err)
				})
			},
			// 根据索引获取当前宫格对应的摄像头对象
			getCamera(index) {
				const deviceCode = this.gridSelections[index]
				if (!deviceCode) {
					// 如果该位置没有选择，返回空对象
					return {}
				}
				const found = this.camera_listData.find(cam => cam.deviceCode === deviceCode)
				if (!found) {
					console.warn(`[getCamera] 宫格${index} 的 deviceCode=${deviceCode} 在列表中找不到`)
					return {}
				}
				return found
			},
			// 切换摄像头选择下拉框
			toggleSelector(index) {
				const newArr = Array(9).fill(false)
				newArr[index] = !this.selectorOpen[index]
				this.selectorOpen = newArr
			},
			// 选择摄像头
			async selectCamera(gridIndex, camera) {
				console.log(`[selectCamera] 宫格${gridIndex} 切换到摄像头:`, camera.deviceName, 'deviceCode:', camera
					.deviceCode,
					'流地址:', camera.flvStreamUrl)

				// 1. 立即关闭下拉菜单
				const newArr = this.selectorOpen.slice()
				newArr[gridIndex] = false
				this.selectorOpen = newArr

				// 2. 更新选择
				this.$set(this.gridSelections, gridIndex, camera.deviceCode)
				console.log(`[selectCamera] 更新后 gridSelections[${gridIndex}]:`, this.gridSelections[gridIndex])

				// 2.1 同步更新当前操作设备 + 拉取该摄像头的设置
				this.operation.deviceCode = camera.deviceCode
				this.pageSetings(camera.deviceCode)

				// 3. 等待旧播放器销毁完成（jessibuca 的 destroy 是异步的，
				//    不 await 的话，旧播放器最后一步 innerHTML='' 会把新播放器刚渲染的画面清掉）
				await this.destroySinglePlayer(gridIndex)

				// 4. 重新初始化该位置播放器（initSinglePlayer 内部会等容器尺寸，无需额外延迟）
				await this.$nextTick()
				console.log(`[selectCamera] 准备重新初始化宫格${gridIndex}`)
				this.initSinglePlayer(gridIndex)

				// 5. 手动选择后重置轮播计时，避免刚选完就被轮播切走
				this.startCarousel()
			},
			// 启动轮播（20 秒一次，单画面换 1 个 / 四画面换 4 个 / 九画面换 9 个）
			startCarousel() {
				this.stopCarousel()
				this.carouselTimer = setInterval(() => {
					this.carouselNext()
				}, 20000)
			},
			// 停止轮播
			stopCarousel() {
				if (this.carouselTimer) {
					clearInterval(this.carouselTimer)
					this.carouselTimer = null
				}
			},
			// 执行一次轮播切换
			carouselNext() {
				// 只用有流地址的摄像头轮播，保证切换后一定能出画面
				const validList = this.camera_listData.filter(cam => cam.flvStreamUrl)
				if (!validList.length) return

				const total = validList.length
				const count = this.maxGrids // 1 / 4 / 9

				// 摄像头总数不足以铺满一屏时，每次只前进 1，避免 (count % total === 0) 导致游标原地不动
				const step = total > count ? count : 1
				this.carouselCursor = (this.carouselCursor + step) % total

				// 为前 count 个宫格分配摄像头（不足则从头循环）
				const newSelections = this.gridSelections.slice()
				for (let i = 0; i < count; i++) {
					const cam = validList[(this.carouselCursor + i) % total]
					newSelections[i] = cam ? cam.deviceCode : ''
				}
				this.gridSelections = newSelections

				console.log('[carouselNext] 轮播切换，cursor:', this.carouselCursor, '宫格数:', count)
				// 全量重建播放器，确保画面展示
				this.initVideoPlayers()
			},
			// 清空播放器容器内的 DOM（canvas/video）
			clearContainer(index) {
				const containerRef = 'jessibucaContainer_' + index
				const containerArr = this.$refs[containerRef]
				const container = Array.isArray(containerArr) ? containerArr[0] : containerArr
				if (container) {
					container.innerHTML = ''
				}
			},
			// 初始化所有视频播放器
			async initVideoPlayers() {
				await this.$nextTick()
				console.log('[initVideoPlayers] 开始, Jessibuca:', !!window.Jessibuca, 'Tab:', this
					.currentTab,
					'最大宫格数:', this.maxGrids)
				if (!window.Jessibuca) {
					console.error('[initVideoPlayers] Jessibuca未加载')
					return
				}
				// 等待旧播放器全部异步销毁完成，再重建（否则新画面会被旧 destroy 清空）
				await this.destroyAllPlayers()
				// 清理重试计数，避免上次残留导致本次直接超时放弃
				this._initRetry = {}

				// 延迟加载避免并发冲突，每个播放器间隔 200ms
				for (let i = 0; i < this.maxGrids; i++) {
					setTimeout(() => {
						this.initSinglePlayer(i)
					}, i * 200)
				}
			},
			// 初始化单个播放器
			async initSinglePlayer(index) {
				const camera = this.getCamera(index);
				const containerRef = 'jessibucaContainer_' + index;
				const containerArr = this.$refs[containerRef];
				const container = Array.isArray(containerArr) ? containerArr[0] : containerArr;

				// 切换 tab 瞬间 DOM 可能还没渲染、或 camera_list 还没返回（无流），轮询重试最多 3s
				if (!container || !camera.flvStreamUrl) {
					if (!this._initRetry) this._initRetry = {};
					this._initRetry[index] = (this._initRetry[index] || 0) + 1;
					if (this._initRetry[index] > 30) {
						console.warn(`[initSinglePlayer] 宫格${index} 初始化重试超时（容器:${!!container} 流:${!!camera.flvStreamUrl}）`);
						delete this._initRetry[index];
						return;
					}
					setTimeout(() => this.initSinglePlayer(index), 100);
					return;
				}
				if (this._initRetry) delete this._initRetry[index];

				// 等容器有真实宽高再初始化（切换/轮播后 DOM 可能还没布局完成，尺寸为 0 会导致画面不出来）
				await new Promise((resolve) => {
					const start = Date.now();
					const check = () => {
						const w = container.clientWidth;
						const h = container.clientHeight;
						if (w > 0 && h > 0) {
							resolve();
						} else if (Date.now() - start > 2000) {
							resolve(); // 2s 超时兜底，避免死等
						} else {
							requestAnimationFrame(check);
						}
					};
					check();
				});

				// 等待期间容器可能已被销毁/切换，重新校验
				const curArr = this.$refs[containerRef];
				const curContainer = Array.isArray(curArr) ? curArr[0] : curArr;
				if (!curContainer) return;

				try {
					const decoderUrl = window.location.origin + process.env.BASE_URL + 'static/jessibuca/decoder.js';

					// 先清空容器，避免旧 canvas/video 残留叠加
					container.innerHTML = '';

					const player = new window.Jessibuca({
						container: container,
						decoder: decoderUrl,
						videoBuffer: 0.2,
						isResize: true, // 关键：监听容器尺寸变化，切换后画面才能正常渲染
						text: "",
						loadingText: "加载中...",
						useMSE: true,
						useWCS: false,
						autoWasm: true,
						forceNoOffscreen: false,
						isNotMute: false,
						timeout: 10,
						hasAudio: false,
						operateBtns: {
							fullscreen: false,
							screenshot: false, // 如果为 false，截图方法可能不可用
							play: false,
							audio: false,
						},
						controlAutoHide: true,
						debug: true, // 开启 debug 模式，看控制台输出
					});

					// 监听更多事件
					player.on('load', () => {
						console.log(`[jessibuca] 播放器${index} 加载完成`);
					});

					player.on('play', () => {
						console.log(`[jessibuca] 播放器${index} 开始播放`);
						// 播放成功后手动 resize 一次，确保 video/canvas 撑满容器
						this.$nextTick(() => {
							try {
								if (player && player.resize) player.resize();
							} catch (e) {
								console.warn(`[jessibuca] 播放器${index} resize 失败:`, e?.message || e);
							}
						});
						// 延迟一下再检查 canvas
						setTimeout(() => {
							const canvas = container.querySelector('canvas');
							console.log(`[jessibuca] 播放器${index} canvas:`, canvas);
						}, 500);
					});

					player.on('error', (error) => {
						console.error(`[jessibuca] 播放器${index} 错误:`, error);
					});

					player.on('screenshot', (data) => {
						console.log(`[jessibuca] 播放器${index} 截图事件:`, data?.substring(0, 100));
					});

					console.log(`[jessibuca] 播放器${index} 开始播放:`, camera.flvStreamUrl);
					player.play(camera.flvStreamUrl);

					while (this.jessibucaPlayers.length <= index) {
						this.jessibucaPlayers.push(null);
					}
					this.jessibucaPlayers[index] = player;

				} catch (err) {
					console.error(`[initSinglePlayer] 初始化失败:`, err);
				}
			},
			// 安全销毁：jessibuca 的 destroy 是异步的，等待其完成，超时兜底避免死等
			_safeDestroy(player, index) {
				return new Promise((resolve) => {
					let settled = false
					const finish = () => {
						if (settled) return
						settled = true
						resolve()
					}
					const timer = setTimeout(() => {
						console.warn(`[destroy] 播放器${index} 销毁超时，强制继续`)
						finish()
					}, 1500)
					try {
						const ret = player.destroy()
						if (ret && typeof ret.then === 'function') {
							ret.then(() => { clearTimeout(timer); finish() })
								.catch(() => { clearTimeout(timer); finish() })
						} else {
							clearTimeout(timer)
							finish()
						}
					} catch (e) {
						clearTimeout(timer)
						finish()
					}
				})
			},
			// 销毁单个播放器（await 异步销毁完成，避免重建时画面被旧播放器清空）
			async destroySinglePlayer(index) {
				const player = this.jessibucaPlayers[index]
				if (!player) return
				this.jessibucaPlayers[index] = null
				console.log(`[destroySinglePlayer] 销毁播放器 ${index}`)
				await this._safeDestroy(player, index)
			},
			// 销毁所有播放器（await 异步销毁完成）
			async destroyAllPlayers() {
				const players = this.jessibucaPlayers.slice()
				this.jessibucaPlayers = []
				await Promise.all(players.map((player, index) => {
					if (player && player.destroy) {
						return this._safeDestroy(player, index)
					}
					return Promise.resolve()
				}))
			},
			camera_overview() {
				this.$http.get(this.$api.BASE_URL_Category.camera_overview).then(res => {
					this.camera_overviewData = res.data;
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	// 完全对齐 eventAlertRight.vue 风格
	.monitor-dashboard {
		position: absolute;
		left: 0;
		top: 90px;
		z-index: 2;
		display: flex;
		width: 100%;
		height: 980px;
		color: #B3C8DC;
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;

		.left-sidebar {
			width: 420px;
			margin-right: 10px;
			display: flex;
			flex-direction: column;
			gap: 10px;

			.info-cards {
				width: 420px;
				background: rgba(10, 22, 40, 0.85);
				border-radius: 8px;
				// border: 1px solid rgba(0, 150, 255, 0.3);3);
				padding: 9px;
				box-sizing: border-box;

				.card {
					width: 100%;
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					justify-content: space-between;
					gap: 8px;
					box-sizing: border-box;

					.card-item {
						text-align: center;
						padding: 7px;
						display: flex;
						flex-direction: column;
						gap: 4px;
						width: 195px;
						height: 64px;
						background: linear-gradient(0deg, #081724 0%, #16283A 100%);
						border-radius: 7px 7px 7px 7px;
						// 		// border: 1px solid #4578A8;

						.label {
							font-size: 10px;
							color: #B3C8DC;
						}

						.value {
							font-size: 16px;
							font-weight: 800;
							color: #B3C8DC;
						}

						.desc {
							font-size: 10px;
							color: #B3C8DC;
						}

						.progress-bar {
							width: 100%;
							height: 12px;
							background: #0F263A;
							border-radius: 100px;
							overflow: hidden;
							margin: 4px 0;

							.progress {
								height: 100%;
								background: linear-gradient(90deg, #7ABFFF 0%, #5FE3FF 100%);
								border-radius: 4px;
							}
						}
					}
				}

				.full {
					margin-top: 10px;

					.card-item {

						height: unset;
					}
				}
			}

			.video-alarm {
				width: 100%;
				height: 603px;
				background: rgba(10, 22, 40, 0.85);
				// border: 1px solid rgba(0, 150, 255, 0.3);
				border-radius: 8px;
				padding: 12px 10px;
				box-sizing: border-box;

				.title {
					font-size: 16px;
					margin-bottom: 10px;
					color: #B3C8DC;
				}

				.desc {
					font-size: 12px;
					color: #B3C8DC;
				}

				.alarm-list {
					.alarm-item {
						width: 100%;
						display: flex;
						height: 65px;
						align-items: center;
						padding: 11px;
						background: linear-gradient(180deg, rgba(122, 191, 255, 0.1) 0%, rgba(122, 191, 255, 0) 100%);
						border-radius: 8px;
						border: 1px solid #7ABFFF;
						margin-bottom: 8px;

						&.urgent {
							background: linear-gradient(0deg, rgba(255, 74, 74, 0.5) 0%, rgba(255, 86, 74, 0) 100%);
							border: 1px solid rgba(255, 74, 74, 0.5);
						}

						&.tracking {
							background: linear-gradient(0deg, rgba(255, 190, 74, 0.5) 0%, rgba(255, 190, 74, 0) 100%);
							border: 1px solid rgba(255, 190, 74, 0.5);
						}

						.alarm-content {
							flex: 1;

							.alarm-title {
								font-weight: bold;
								font-size: 12px;
								color: #B3C8DC;
								margin-bottom: 8px;
							}

							.alarm-time {
								font-size: 10px;
								color: #B3C8DC;
							}
						}

						.alarm-action {
							gap: 6px;

							.floor {
								width: 49px;
								text-align: center;
								height: 23px;
								line-height: 22px;
								background: #284769;
								border-radius: 4px;
								border: 1px solid #7ABFFF;
								font-size: 10px;
								color: #B3C8DC;
							}

							.status {
								font-size: 10px;
								color: #B3C8DC;
							}
						}
					}
				}
			}

			.ptz-control {
				width: 100%;
				height: 280px;
				background: rgba(10, 22, 40, 0.85);
				border-radius: 8px;
				padding: 12px 10px;
				box-sizing: border-box;
				margin-top: auto;

				.title {
					font-size: 16px;
					margin-bottom: 10px;
					color: #B3C8DC;
				}

				.desc {
					font-weight: 500;
					font-size: 12px;
					color: #B3C8DC;
				}

				.flex-center {
					width: 100%;
					margin: 0px auto;
				}

				.ptz-buttons {
					display: flex;
					flex-direction: column;
					gap: 27px;

					:nth-child(2) {
						margin-left: -20px;
					}

					.right {
						margin-left: 20px;
					}

					.ptz-btn {
						width: 91px;
						height: 38px;
						line-height: 37px;
						text-align: center;
						background: linear-gradient(85deg, #2E587B 0%, #233443 100%);
						border-radius: 30px 30px 30px 30px;
						border: 1px solid #7ABFFF;
						cursor: pointer;
						font-size: 16px;
						color: #B3C8DC;

						&:hover {
							background: #349DFF;
							border-color: #7ABFFF;
							color: #B3C8DC;
						}
					}
				}

				.direction-control {
					width: 164px;
					height: 164px;
					margin: 0 24px;
					background-size: 100%;
					background-repeat: no-repeat;
					background-image: url("../assets/yk.png");
					position: relative;
					cursor: pointer;

					.dir-btn {
						font-size: 18px;
						color: #AFD8FF;



						&.up {
							position: absolute;
							top: 15px;
							left: 50%;
							transform: translate(-50%, 0);
						}

						&.left {
							position: absolute;
							top: 50%;
							left: 15px;
							transform: translate(0, -50%);
						}

						&.right {
							position: absolute;
							top: 50%;
							right: 15px;
							transform: translate(0, -50%);
						}

						&.down {
							position: absolute;
							bottom: 15px;
							left: 50%;
							transform: translate(-50%, 0);
						}

						&.center {
							text-align: center;
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
						}


					}
				}

				.zoom-control {
					.label {
						font-size: 12px;
						color: #B3C8DC;
						margin-bottom: 8px;
						display: block;
					}

					.zoom-slider {
						display: flex;
						align-items: center;
						gap: 8px;

						.slider-track {
							flex: 1;
							height: 8px;
							background: #172434;
							border-radius: 4px;
							overflow: hidden;

							.slider-fill {
								height: 100%;
								background: #349DFF;
								border-radius: 4px;
							}
						}

						.value {
							font-size: 12px;
							color: #B3C8DC;
						}
					}
				}
			}
		}

		.main-content {
			flex: 1;
			width: 1037px;
			background: rgba(9, 23, 36, 0.9);
			border-radius: 12px;
			// 		// border: 1px solid #4578A8;

			.header {
				width: 1017px;
				height: 78px;
				margin: 10px auto 0 auto;
				padding: 14px;
				background: linear-gradient(0deg, #081724 0%, #16283A 100%);
				border-radius: 8px;
				// 		// border: 1px solid #4578A8;

				.title {
					display: flex;
					align-items: center;
					gap: 8px;
					margin-bottom: 10px;

					.dot {
						width: 10px;
						height: 10px;
						background: #5FE3FF;
						box-shadow: 0px 0px 4px 0px rgba(95, 227, 255, 0.5);
						border-radius: 50%;
						margin-right: 10px;
					}

					.text {
						font-size: 18px;
						color: #B3C8DC;
					}
				}

				.desc {
					font-size: 12px;
					color: #B3C8DC;
					margin-left: 30px;
				}

			}

			.tab-buttons {
				display: flex;
				gap: 6px;
				padding: 10px;

				.tab-btn {
					width: 90px;
					height: 30px;
					line-height: 28px;
					text-align: center;
					background: #172434;
					border-radius: 6px;
					border: 1px solid #2C3D52;
					font-size: 14px;
					color: #B3C8DC;
					cursor: pointer;

					&.active {
						color: #B3C8DC;
						background: #349DFF;
						border-color: #7ABFFF;
					}
				}
			}

			.video-container {
				flex: 1;
				padding: 0 10px;
				display: grid;
				gap: 8px;

				&.single {
					grid-template-columns: 1fr;
				}

				&.four {
					grid-template-columns: 1fr 1fr;

					.video-item .video-content {
						height: 350px;
						flex: unset;
					}

					.video-item .video-header .camera-select {
						font-size: 10px;
						padding: 3px 6px;

						.fh {
							width: 15px;
							height: 10px;
							margin-left: 15px;
						}

						.title {
							font-size: 10px;
							color: #B3C8DC;
							margin-bottom: 5px;
							font-weight: normal;
						}
					}
				}

				&.nine {
					grid-template-columns: repeat(3, 1fr);

					.video-item .video-content {
						height: 210px;
						flex: unset;
					}

					.video-item .video-footer .stat-item .label {
						margin-bottom: 5px;
						font-size: 10px;
					}

					.video-item .video-header .camera-select {
						font-size: 10px;
						padding: 3px 6px;

						.fh {
							width: 15px;
							height: 10px;
							margin-left: 15px;
						}

						.title {
							font-size: 10px;
							color: #B3C8DC;
							margin-bottom: 5px;
							font-weight: normal;
						}
					}
				}

				.video-item {
					background: rgba(10, 22, 40, 0.85);
					border: 1px solid rgba(0, 150, 255, 0.3);
					border-radius: 8px;
					display: flex;
					flex-direction: column;
					overflow: hidden;

					.video-header {
						padding: 8px 10px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						background: rgba(10, 22, 40, 0.9);
						border-bottom: 1px solid rgba(0, 150, 255, 0.2);

						.camera-select {
							cursor: pointer;
							padding: 5px 10px;
							border-radius: 8px;
							// 		// border: 1px solid #4578A8;
							font-size: 12px;
							color: #B3C8DC;
							display: flex;
							align-items: center;
							justify-content: space-between;
							position: relative;

							.fh {
								width: 25px;
								height: 20px;
								margin-left: 30px;
							}

							.title {
								font-weight: 800;
								font-size: 16px;
								color: #B3C8DC;
								margin-bottom: 5px;
							}

							.camera-dropdown {
								position: absolute;
								top: calc(100% + 4px);
								left: 0;
								right: 0;
								max-height: 240px;
								overflow-y: auto;
								background: rgba(9, 23, 36, 0.98);
								// 		// border: 1px solid #4578A8;
								border-radius: 6px;
								z-index: 99;
								padding: 4px 0;
								box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);

								.dropdown-item {
									padding: 6px 10px;
									display: flex;
									justify-content: space-between;
									align-items: center;
									gap: 8px;
									cursor: pointer;
									font-size: 12px;
									color: #B3C8DC;
									transition: all 0.2s;

									.name {
										color: #B3C8DC;
										font-weight: 500;
										flex: 1;
										overflow: hidden;
										text-overflow: ellipsis;
										white-space: nowrap;
									}

									.area {
										font-size: 10px;
										color: #7ABFFF;
										flex-shrink: 0;
									}

									&:hover {
										background: rgba(69, 120, 168, 0.3);
									}

									&.active {
										background: rgba(54, 209, 255, 0.2);
										border-left: 2px solid #36d1ff;

										.name {
											color: #36d1ff;
										}
									}
								}

								.dropdown-empty {
									padding: 12px;
									text-align: center;
									color: #B3C8DC;
									font-size: 12px;
								}

								&::-webkit-scrollbar {
									width: 4px;
								}

								&::-webkit-scrollbar-thumb {
									background: #4578A8;
									border-radius: 2px;
								}
							}
						}

						.main-tag,
						.status-tag {
							background: #0E161E;
							border-radius: 4px;
							border: 1px solid #7ABFFF;
							padding: 2px 6px;
							font-size: 10px;
							color: #B3C8DC;
						}
					}

					.video-content {
						height: 745px;
						position: relative;
						background: #000;
						display: flex;
						align-items: center;
						justify-content: center;

						.video-img {
							width: 100%;
							height: 100%;
							position: absolute;
							top: 0;
							left: 0;
							right: 0;
							bottom: 0;
						}

						.no-signal {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							color: #B3C8DC;
							font-size: 14px;
							z-index: 1;
							pointer-events: none;
						}
					}

					::v-deep .video-img canvas,
					::v-deep .video-img video {
						width: 100% !important;
						height: 100% !important;
						top: 0 !important;
						left: 0 !important;
						transform:none !important;
						// object-fit: cover;
					}

					.video-footer {
						padding: 8px;
						display: flex;
						display: none;
						justify-content: space-around;
						background: rgba(10, 22, 40, 0.9);
						border-top: 1px solid rgba(0, 150, 255, 0.2);

						.stat-item {
							display: flex;
							flex-direction: column;
							align-items: center;

							.label {
								font-size: 14px;
								color: #B3C8DC;
								margin-bottom: 7px;
							}

							.value {
								font-size: 12px;
								font-weight: 800;
								color: #B3C8DC;
							}
						}
					}
				}
			}
		}

		.right-sidebar {
			width: 420px;
			margin-left: 10px;
			display: flex;
			flex-direction: column;
			gap: 10px;

			.monitor-settings {
				background: rgba(10, 22, 40, 0.85);
				// border: 1px solid rgba(0, 150, 255, 0.3);
				border-radius: 8px;
				padding: 12px 10px;
				box-sizing: border-box;
				position: relative;
				z-index: 100;

				.title {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 15px;

					span:first-child {
						font-size: 16px;
						color: #B3C8DC;
					}

					.subtitle {
						font-size: 12px;
						color: #B3C8DC;
					}
				}

				.camera-selector {
					background: rgba(#091724, 0.8);
					// border: 1px solid #4578A8;
					border-radius: 12px;
					padding: 10px 12px;
					position: relative;
					z-index: 200;

					.input-box {
						width: 180px;
						height: 30px;
						line-height: 30px;
						padding: 0 8px;
						background: #172434;
						border-radius: 6px;
						border: 1px solid #2C3D52;
						font-size: 12px;
						color: #B3C8DC;
						position: relative;
						cursor: pointer;
						display: flex;
						align-items: center;
						justify-content: space-between;
						z-index: 201;

						.arrow-icon {
							width: 12px;
							height: 12px;
							flex-shrink: 0;
						}

						.camera-dropdown {
							position: absolute;
							top: calc(100% + 4px);
							left: 0;
							right: 0;
							max-height: 240px;
							overflow-y: auto;
							background: rgba(9, 23, 36, 0.98);
							// 		// border: 1px solid #4578A8;
							border-radius: 6px;
							z-index: 9999 !important;
							padding: 4px 0;
							box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);

							.dropdown-item {
								padding: 0px 10px;
								display: flex;
								justify-content: space-between;
								align-items: center;
								gap: 8px;
								cursor: pointer;
								font-size: 12px;
								color: #B3C8DC;
								transition: all 0.2s;

								.name {
									color: #B3C8DC;
									font-weight: 500;
									flex: 1;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}

								.area {
									font-size: 10px;
									color: #7ABFFF;
									flex-shrink: 0;
								}

								&:hover {
									background: rgba(54, 209, 255, 0.1);
								}

								&.active {
									background: rgba(54, 209, 255, 0.15);
									border-left: 2px solid #36d1ff;

									.name {
										color: #36d1ff;
									}
								}
							}

							.dropdown-empty {
								padding: 12px;
								text-align: center;
								font-size: 12px;
								color: #5a7a96;
							}
						}
					}

					.checkbox-label {
						font-size: 12px;
						color: #B3C8DC;
						display: flex;
						align-items: center;
						gap: 4px;

						::v-deep input[type="checkbox"] {
							-webkit-appearance: none;
							-moz-appearance: none;
							appearance: none;
							width: 14px;
							height: 14px;
							background: transparent;
							border: 1px solid #4578A8 !important;
							border-radius: 3px;
							cursor: pointer;
							position: relative;
							margin: 0;
							outline: none;
							transition: all 0.2s ease;

							&:hover {
								border-color: #36d1ff;
							}

							&:checked {
								background: transparent;
								border-color: #36d1ff;

								&::after {
									content: '';
									position: absolute;
									left: 3px;
									top: 0px;
									width: 4px;
									height: 8px;
									border: solid #36d1ff;
									border-width: 0 2px 2px 0;
									transform: rotate(45deg);
								}
							}
						}
					}
				}

				.algo-settings {
					margin-bottom: 16px;
					background: rgba(#091724, 0.8);
					// border: 1px solid #4578A8;
					border-radius: 12px;
					margin-top: 10px;
					padding: 10px 12px;

					.section-title {
						font-size: 14px;
						color: #B3C8DC;
						margin-bottom: 8px;
					}

					.algo-list {
						display: grid;
						grid-template-columns: repeat(3, 1fr);
						gap: 8px;

						.algo-item {
							background: rgba(#091724, 0.8);
							border: 1px solid #4578A8;
							border-radius: 12px;
							padding: 5px;
							font-size: 12px;
							color: #B3C8DC;
							display: flex;
							align-items: center;
							gap: 4px;

							::v-deep input[type="checkbox"] {
								-webkit-appearance: none;
								-moz-appearance: none;
								appearance: none;
								width: 14px;
								height: 14px;
								background: transparent;
								border: 1px solid #4578A8;
								border-radius: 3px;
								cursor: pointer;
								position: relative;
								margin: 0;
								outline: none;
								transition: all 0.2s ease;

								&:hover {
									border-color: #36d1ff;
								}

								&:checked {
									background: transparent;
									border-color: #36d1ff;

									&::after {
										content: '';
										position: absolute;
										left: 3px;
										top: 0px;
										width: 4px;
										height: 8px;
										border: solid #36d1ff;
										border-width: 0 2px 2px 0;
										transform: rotate(45deg);
									}
								}
							}
						}
					}

					.count {
						text-align: right;
						font-size: 10px;
						color: #B3C8DC;
					}

					.algo-empty {
						text-align: center;
						font-size: 12px;
						color: #5a7088;
						padding: 16px 0;
					}
				}

			}

			.ai-assistant {
				flex: 1;
				background: rgba(10, 22, 40, 0.85);
				border: 1px solid rgba(0, 150, 255, 0.3);
				border-radius: 8px;
				padding: 12px 10px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;

				.title {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 15px;

					span:first-child {
						font-size: 16px;
						color: #B3C8DC;
					}

					.toggle-btn {
						font-size: 12px;
						color: #B3C8DC;
						cursor: pointer;
					}
				}

				.chat-content {
					flex: 1;
					overflow-y: auto;

					.welcome {
						display: flex;
						align-items: center;
						gap: 8px;
						margin-bottom: 12px;

						.icon {
							font-size: 24px;
						}

						.text {
							p {
								margin: 2px 0;
								font-size: 12px;
								color: #B3C8DC;
							}

							p:last-child {
								color: #B3C8DC;
								font-size: 11px;
							}
						}
					}

					.quick-questions {
						display: flex;
						flex-direction: column;
						gap: 8px;

						.question-item {
							height: 30px;
							line-height: 30px;
							padding: 0 8px;
							background: #172434;
							border-radius: 6px;
							border: 1px solid #2C3D52;
							font-size: 12px;
							color: #B3C8DC;
							cursor: pointer;

							&:hover {
								background: #349DFF;
								border-color: #7ABFFF;
								color: #B3C8DC;
							}
						}
					}
				}

				.input-area {
					display: flex;
					gap: 8px;
					margin-top: 10px;

					input {
						flex: 1;
						height: 30px;
						padding: 0 8px;
						background: #172434;
						border-radius: 6px;
						border: 1px solid #2C3D52;
						color: #B3C8DC;
						font-size: 12px;

						&::placeholder {
							color: #B3C8DC;
						}
					}

					.send-btn {
						width: 30px;
						height: 30px;
						background: #349DFF;
						border: none;
						border-radius: 6px;
						color: #B3C8DC;
						cursor: pointer;
					}
				}
			}
		}
	}

	.panel-section {
		background: rgba(#091724, 0.9);
		border-radius: 16px;
		padding: 12px;
		box-shadow: 0 4px 15px rgba(69, 120, 168, 0.2);

		.section-title {
			font-size: 16px;
			font-weight: bold;
		}

		.section-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 15px;

			.more-btn {
				color: #B3C8DC;
				font-size: 12px;
			}

			.chart-tabs {
				display: flex;
				gap: 10px;

				.tab {
					cursor: pointer;
					padding: 4px 8px;
					border-radius: 4px;
					color: #ccc;
					font-size: 12px;

					&.active {
						background: #4A98F7;
						color: #B3C8DC;
					}
				}
			}

			.legend {
				display: flex;
				gap: 10px;
				font-size: 10px;
				color: #ccc;

				.legend-item {
					display: flex;
					align-items: center;
					gap: 4px;

					.dot {
						width: 8px;
						height: 8px;
						border-radius: 50%;

						&.red {
							background: #ff4d4f;
						}

						&.yellow {
							background: #ffc107;
						}

						&.orange {
							background: #ff9800;
						}
					}
				}
			}
		}

		.echarts-trend {
			width: 100%;
			height: 160px;
		}

		.alarm-list {
			.alarm-item {
				width: 401px;
				height: 48px;
				display: flex;
				align-items: center;
				gap: 10px;
				padding: 6px 10px;
				border-radius: 8px;
				margin-bottom: 11px;
				font-size: 12px;

				.icon-box {
					display: flex;
					align-items: center;
					margin-right: 10px;

					.icon {
						width: 15px;
						height: 15px;
						margin-right: 5px;
						margin-top: -3px;
					}

					.icon-text {
						font-weight: 500;
						font-size: 10px;
						color: #FF4A4A;
					}
				}

				.handle-btn {
					cursor: pointer;
					width: 50px;
					height: 20px;
					text-align: center;
					line-height: 16px;
					font-size: 10px;
					color: #B3C8DC;
					border-radius: 4px 4px 4px 4px;
					background: #582A26;
					border: 1px solid #FF5749;
				}

				&.red {
					border: 1px solid #FF4A4A;
					background: linear-gradient(0deg, rgba(255, 74, 74, 0.5) 0%, rgba(255, 86, 74, 0) 100%);

					.icon-text {
						color: #FF4A4A;
					}
				}

				&.yellow {
					border: 1px solid #FFBE4A;
					background: linear-gradient(0deg, rgba(255, 190, 74, 0.5) 0%, rgba(255, 190, 74, 0) 100%);

					.icon-text {
						color: #FFBE4A;
					}

					.handle-btn {
						background: #4B391A;
						border: 1px solid #FFBE4A;
					}
				}

				&.orange {
					border: 1px solid #DA7E40;
					background: linear-gradient(0deg, rgba(218, 126, 64, 0.5) 0%, rgba(218, 126, 64, 0) 100%);

					.icon-text {
						color: #DA7E40;
					}

					.handle-btn {
						background: #2B1B11;
						border: 1px solid #DA7E40;
					}
				}

				.alarm-content {
					flex: 1;

					.alarm-title {
						color: #B3C8DC;
						font-weight: bold;
						font-size: 12px;
						margin-bottom: 4px;
					}

					.alarm-desc {
						font-size: 10px;
						color: #B3C8DC;
					}
				}

				.alarm-time {
					font-size: 10px;
					color: #B3C8DC;
				}
			}
		}

		.video-grid {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 11px;

			.video-item {
				width: 195px;
				height: 105px;
				border-radius: 10px;
				position: relative;
				overflow: hidden;
				// border: 1px solid #4578A8;

				.video-header {
					width: 100%;
					position: absolute;
					top: 0px;
					left: 0px;
					background: linear-gradient(90deg, #081724 0%, rgba(102, 102, 102, 0) 100%);
					padding: 4px 7px;
					font-size: 10px;
					z-index: 2;
					pointer-events: none;
				}

				.video-img {
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 1;
				}

				.video-img ::v-deep canvas,
				.video-img ::v-deep video {
					width: 100% !important;
					height: 100% !important;
					display: block !important;
					object-fit: cover;
				}
			}
		}
	}

	.ai-section {
		height: 700px;

		.section-header {
			.subtitle {
				font-size: 10px;
				color: rgba(#B3C8DC, 0.6);
				margin-left: 8px;
			}
		}

		.ai-content {
			width: 401px;
			padding: 10px;
			height: 580px;
			margin: 10px auto;
			background: rgba(9, 23, 36, 0.9);
			border-radius: 10px;
			// 		// border: 1px solid #4578A8;

			// 分析输入区域
			.analyze-input-wrap {
				margin-bottom: 12px;

				::v-deep .input-box {
					width: 100%;
					height: 36px;
					background: rgba(9, 23, 36, 0.9);
					border-radius: 6px;
					border: 1px solid #4578A8;
					font-size: 11px;
					padding: 0 10px;
					color: #B3C8DC;
					box-sizing: border-box;
					margin-bottom: 8px;
					outline: none;
					transition: border-color 0.2s;

					&::placeholder {
						color: #B3C8DC;
					}

					&:focus {
						border-color: #36d1ff;
					}

					&:disabled {
						opacity: 0.5;
						cursor: not-allowed;
					}
				}

				.analyze-btn {
					width: 100%;
					height: 36px;
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 6px;
					background: linear-gradient(90deg, #1a5fa8, #36d1ff);
					border: none;
					border-radius: 6px;
					font-size: 12px;
					color: #B3C8DC;
					cursor: pointer;
					transition: opacity 0.2s;

					.icon {
						width: 16px;
						height: 16px;
					}

					&:disabled {
						opacity: 0.5;
						cursor: not-allowed;
					}

					&:not(:disabled):hover {
						opacity: 0.85;
					}
				}
			}

			// 分析结果
			.analyze-result {
				background: rgba(13, 32, 53, 0.9);
				border: 1px solid rgba(54, 209, 255, 0.3);
				border-radius: 8px;
				padding: 10px;
				max-height: 420px;
				overflow-y: auto;

				.result-header {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 10px;
					padding-bottom: 6px;
					border-bottom: 1px solid rgba(69, 120, 168, 0.3);

					.result-title {
						font-size: 13px;
						color: #36d1ff;
						font-weight: bold;
					}

					.cost-time {
						font-size: 10px;
						color: rgba(179, 200, 220, 0.6);
					}
				}

				.result-summary,
				.result-answer {
					margin-bottom: 12px;

					.summary-label,
					.answer-label {
						font-size: 11px;
						color: #7ABFFF;
						margin-bottom: 4px;
					}

					.summary-text,
					.answer-text {
						font-size: 11px;
						color: #B3C8DC;
						line-height: 1.6;
					}
				}

				.result-details {
					.details-title {
						font-size: 11px;
						color: #7ABFFF;
						margin-bottom: 8px;
					}

					.detail-grid {
						display: grid;
						grid-template-columns: 1fr 1fr;
						gap: 6px 10px;

						.detail-item {
							display: flex;
							justify-content: space-between;
							align-items: center;
							font-size: 10px;
							padding: 4px 6px;
							background: rgba(9, 23, 36, 0.6);
							border-radius: 4px;

							.label {
								color: rgba(179, 200, 220, 0.8);
							}

							.value {
								font-weight: bold;

								&.danger {
									color: #ff4d4d;
								}

								&.warning {
									color: #ffc107;
								}

								&.normal {
									color: #36d1ff;
								}
							}
						}
					}
				}
			}

			// 分析错误
			.analyze-error {
				display: flex;
				align-items: center;
				gap: 8px;
				padding: 10px;
				background: rgba(255, 77, 77, 0.1);
				border: 1px solid rgba(255, 77, 77, 0.4);
				border-radius: 6px;
				font-size: 11px;
				color: #ff7875;

				.icon {
					width: 14px;
					height: 14px;
				}
			}
		}
	}

	/* ===== 智能分析 ===== */
	.preset-questions {
		margin-bottom: 12px;

		.preset-title {
			font-size: 12px;
			color: #7ABFFF;
			margin-bottom: 6px;
		}

		.preset-list {}

		.preset-item {
			padding: 4px 8px;
			margin-bottom: 10px;
			background: rgba(9, 23, 36, 0.6);
			border: 1px solid #36d1ff;
			border-radius: 4px;
			font-size: 11px;
			color: #B3C8DC;
			cursor: pointer;

			&:hover {
				background: rgba(54, 209, 255, .35);
			}

			&.disabled {
				opacity: .5;
				cursor: not-allowed;
			}
		}
	}

	.single-only-tip {
		text-align: center;
		color: #ff7875;
		font-size: 12px;
		padding: 20px 0;
	}

	.result-block {
		margin-bottom: 10px;

		.label {
			font-size: 11px;
			color: #7ABFFF;
			margin-bottom: 4px;
		}

		.text {
			font-size: 11px;
			color: #B3C8DC;
			line-height: 1.6;
		}
	}

	.result-details {
		margin-top: 10px;

		.label {
			font-size: 11px;
			color: #7ABFFF;
			margin-bottom: 6px;
		}

		.detail-grid {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 6px;
		}

		.detail-item {
			display: flex;
			justify-content: space-between;
			padding: 4px 6px;
			background: rgba(9, 23, 36, .6);
			border-radius: 4px;
			font-size: 10px;

			.v.danger {
				color: #ff4d4d;
			}

			.v.warning {
				color: #ffc107;
			}

			.v.normal {
				color: #36d1ff;
			}
		}
	}

	.analyze-error {
		margin-top: 10px;
		padding: 10px;
		background: rgba(255, 77, 77, .1);
		border: 1px solid rgba(255, 77, 77, .4);
		border-radius: 6px;
		font-size: 11px;
		color: #ff7875;
	}
</style>